import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-donor-contact-function.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetDonorContactFunctionDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metDonorContactFunctionEntity = useAppSelector(state => state.metDonorContactFunction.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metDonorContactFunctionDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.detail.title">MetDonorContactFunction</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metDonorContactFunctionEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.code">Code</Translate>
            </span>
          </dt>
          <dd>{metDonorContactFunctionEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.name">Name</Translate>
            </span>
          </dt>
          <dd>{metDonorContactFunctionEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{metDonorContactFunctionEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{metDonorContactFunctionEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.status">Status</Translate>
            </span>
          </dt>
          <dd>{metDonorContactFunctionEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-donor-contact-function" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-donor-contact-function/${metDonorContactFunctionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetDonorContactFunctionDetail;
